import {useCatalog} from '../../../../../provider/catalogs/catalogs-hook';
import {useGoogleAccounts} from '../../../../../service/accounts/accounts-hook';
import {ProvidersIdsEnum} from '../../../../../util/type';
import {AccountSelector} from '../account-selector/account-selector';

type PropsType = {
    brandId: number;
    onSelectAccount: (accountId: number) => void;
};

export function GoogleAccountSelector(props: PropsType): JSX.Element {
    const {brandId, onSelectAccount} = props;

    const {
        result: accountsResult,
        reset: reloadAccounts,
        isInProgress: isAccountsInProgress,
        processError: accountsError,
        linkingSrc,
    } = useGoogleAccounts({brandId});

    const {catalog: catalogInfo, isLoading: isCatalogDataInProgress} = useCatalog(ProvidersIdsEnum.google);

    return (
        <AccountSelector
            accounts={accountsResult}
            catalogInfo={catalogInfo}
            hasError={Boolean(accountsError)}
            isInProgress={isCatalogDataInProgress || isAccountsInProgress}
            linkingSrc={linkingSrc}
            onSelectAccount={onSelectAccount}
            reloadAccounts={reloadAccounts}
        />
    );
}
